import React from "react";

import { initializeApollo, addApolloState } from "../../../../utils/appollo";

import { GET_CLUB_HEADER_DATA } from "../../../../graphql/queries/queriesClub";
import { withConfig } from "../../../../utils/withConfig";
import { CARD_TEMPLATES_GROUP } from "../../../../graphql/queries/queriesCard";
import { SubscriptionPage } from "../../../../components/pagesComponents/Clubs/routePages";
// import { getClubSlugPathsBlocking } from "../../../../utils/getClubSlugPaths";
import { getSeoFields } from "../../../../utils/getSeoFields";
import { getCommonClubData } from "../../../../utils/getCommonClubData";
import { getPropsDecorator } from "../../../../utils/getPropsDecorator";

// export const getStaticPaths = getClubSlugPathsBlocking;

const callback = async ({ locale, query: { club } }) => {
  //params

  const apolloClient = initializeApollo({ key: club, locale });

  const queries = [
    { query: GET_CLUB_HEADER_DATA, variables: { showOffer: false } },

    // { query: CARD_TEMPLATES },
    { query: CARD_TEMPLATES_GROUP },
  ];
  const promises = queries.map(({ query, variables }) => apolloClient.query({ query, variables }));

  const [{ data: { club: clubData = {} } = {} }] = await Promise.all(promises);

  const commonClubData = getCommonClubData(clubData);
  const { cardOpenPriceEnabled } = clubData;

  const pageProps = {
    props: {
      club,
      locale,
      tags: getSeoFields({ ...commonClubData }),
      authProtected: !cardOpenPriceEnabled,
      cardOpenPriceEnabled,
      ...(await withConfig(locale)),
    },
  };

  return addApolloState(apolloClient, pageProps);
};

// export const getStaticProps = getStaticPropsDecorator(callback);
export const getServerSideProps = getPropsDecorator(callback);

const Subscription = ({ cardOpenPriceEnabled }) => {
  return <SubscriptionPage cardOpenPriceEnabled={cardOpenPriceEnabled} />;
};

export default Subscription;
